import { captureAuthError, renderAuthError } from '@formosa/shared/i18n/authErrorState';
import { useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { groupTripApi } from '../../api/groupTripApi';
import { useTravelTranslation } from '../../app/TravelLocaleContext';
import GroupTripDateConflictNotice from './GroupTripDateConflictNotice';
import {
  groupTripDateConflicts,
  isGroupTripDateConflictError,
  isGroupTripDateConflictRetryable,
} from './groupTripModel';
import './group-trip.css';

export default function AcceptGroupTripClaimPage() {
  const [searchParams] = useSearchParams();
  const hashToken = typeof window === 'undefined'
    ? ''
    : decodeURIComponent(window.location.hash.replace(/^#/, ''));
  const token = searchParams.get('token') || hashToken;
  const { t } = useTravelTranslation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  const [dateConflict, setDateConflict] = useState(null);
  const [busy, setBusy] = useState(false);

  async function accept() {
    if (!token || busy) return;
    setBusy(true);
    setError(null);
    setDateConflict(null);
    try {
      const traveler = await groupTripApi.acceptTravelerClaim(token);
      const groupTripId = traveler?.groupTripId;
      navigate(groupTripId ? `/public/group-trips/${groupTripId}` : '/explore', { replace: true });
    } catch (cause) {
      if (isGroupTripDateConflictError(cause)) {
        setDateConflict(isGroupTripDateConflictRetryable(cause)
          ? { variant: 'busy', trips: [] }
          : { variant: 'blocked', trips: groupTripDateConflicts(cause) });
      } else {
        setError(captureAuthError(cause, 'travel.common.actionFailed'));
      }
      setBusy(false);
    }
  }

  return (
    <section className="group-trips__panel" data-testid="accept-traveler-claim">
      <h1>{t('travel.groupTrip.claimAccept')}</h1>
      {error ? <p className="group-trips__error" role="alert">{renderAuthError(error, t)}</p> : null}
      {dateConflict ? <GroupTripDateConflictNotice variant={dateConflict.variant} trips={dateConflict.trips} /> : null}
      {token ? (
        <button type="button" disabled={busy} onClick={accept} data-testid="accept-traveler-claim-submit">
          {t('travel.groupTrip.claimAccept')}
        </button>
      ) : (
        <p className="group-trips__hint">{t('travel.groupTrip.notFound')}</p>
      )}
      <Link to="/explore">{t('travel.groupTrip.backToList')}</Link>
    </section>
  );
}
